import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Card, InputGroup, Col, Row, Pagination, Table, OverlayTrigger, Tooltip } from "react-bootstrap";

import { FaEdit, FaExchangeAlt } from "react-icons/fa";
import { GiKiwiBird } from "react-icons/gi";

import Navbar from "../../bars/Navbar";
import Sidebar from "../../bars/Sidebar";

import {
  createUser,
  getUserById,
  fetchUsers,
  updateDetailUser,
  DisabledUser,
  ActiveUser,

} from "../../services/apiService";

import "../../App.css";

import { Bs123, BsBriefcaseFill, BsChevronLeft, BsChevronRight, BsEye, BsEyeSlash, BsFillPersonVcardFill, BsFolderFill, BsPersonFillAdd, BsPersonFillGear, BsPersonLinesFill } from "react-icons/bs";
import { FcSearch } from "react-icons/fc";

export default function UserList() {
  document.title = "Lista de Usuarios";

  const [formData, setFormData] = useState({
    id:"",
    user:"",
    nombres:"",
    apellidos:"",
    tipoUserId:"4", //default Junior
    password:""
  });

  const resetForm = () => {
    setFormData("");
    setSuccess("");
    setError("");
    setFieldErrors({})
    setNameUser("");
  };

  const [users, setUsers] = useState([]);
  const [nameuser, setNameUser] = useState([]);
  const [error, setError] = useState(null);
  const [showCodigo, setShowCodigo] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [success, setSuccess] = useState(false);
  // eslint-disable-next-line
  const [fieldErrors, setFieldErrors] = useState({});

  // Paginación
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  // Inicio Paginación
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(0);
  };
  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };
  const handleNext = () => {
    if (totalPages === 0) return;

    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };
  const getPaginationItems = () => {
    let items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    // Ajustar si estamos cerca del final
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // Primera página
    if (startPage > 0) {
      items.push(
        <Pagination.Item
          key={1}
          active={currentPage === 0}
          onClick={() => handlePageChange(1)}
        >
          1
        </Pagination.Item>
      );
      if (startPage > 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }

    // Páginas intermedias
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i + 1}
          active={i === currentPage}
          onClick={() => handlePageChange(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      );
    }

    // Última página
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages - 1}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };
  // Fin Paginación


  const fetchData = async () => {
    try {
      let response;

      response = await fetchUsers(currentPage, pageSize, searchTerm);

      setUsers(response?.content || []);
      setTotalPages(response?.totalPages || 0);
      setTotalElements(response?.totalElements || 0);

    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line 
  }, [currentPage, pageSize, searchTerm]);



  const handleToggleUserStatus = async (username) => {

    try {
      if (username.activo) {
        await DisabledUser(username.id);
      }else {
        await ActiveUser(username.id);
      }
      await fetchData(0, 10);
    } catch (error) {
      alert(error.message);
    }
  };

  const generateUsername = (nombres, apellidos) => {
    if (!nombres || !apellidos) return "";

    const primerNombre = nombres.trim().split(" ")[0];
    const primerApellido = apellidos.trim().split(" ")[0];

    const username =
      primerNombre.charAt(0) + primerApellido;

    return username
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, ""); // elimina acentos
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;

    if (name === "rfc") {
      newValue = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 13);
    }

    setFieldErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => {
      const updated = { ...prev, [name]: newValue };

      if (name === "nombres" || name === "apellidoPaterno") {
        updated.username = generateUsername(
          updated.nombres,
          updated.apellidoPaterno
        );
      }

      return updated;
    });


  };

  const handleOpenModalAdd = () => {
    setShowModalAdd(true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      if (
        !formData.nombres.trim()

      ) {
        setError("Faltan campos por llenar");
        setTimeout(() => setError(false), 3000);
        return;
      }

      const payload = {
        id: formData.id,
        user: formData.user,
        nombres: formData.nombres,
        apellidos: formData.apellidos,
        tipoUserId: formData.tipoUsuario,
        password: formData.password

      };

      await createUser(payload);
      setSuccess(true);

      await fetchData(0, 10);

      setTimeout(() => {
        setSuccess(false);
        setShowModalAdd(false);
        resetForm();
      }, 2000);

    } catch (err) {
      const response = err.response?.data;
      if (response) {
        setFieldErrors(response || "Ocurrió un error inesperado");
      } else {
        setError(response || "Ocurrió un error inesperado");
      }
    }
  };

  const handleOpenModal = async (id, nombre) => {
    setNameUser(nombre);


    try {
      const UserData = await getUserById(id);

      //Aqui se llena la variable local con lo que trae el back
      // de izquierda(local) a derecha(back)

      setFormData({
        id: UserData.id,
        user: UserData.user,
        nombres: UserData.nombres,
        apellidos: UserData.apellidos,
        //contrasena: UserData.contrasena,
        tipoUsuario: UserData.tipoUser.id,
      });

      setShowModal(true);

    } catch (error) {
      console.error("Error al cargar el usuario:", error);
      setError("No se pudo cargar el usuario para editar");
    }
  };
  const handleSubmitCambios = async () => {
    try {

      //Aqui se llena la variable back con lo que tenemos en local
      // de izquierda(back) a derecha(local)
      /* if (
        !formData.apellidos?.trim()

      ) {
        setError("Faltan campos por llenar");
        setTimeout(() => setError(false), 3000);
        return;
      } */

      const payload = {
        user: formData.user,
        nombres: formData.nombres,
        apellidos: formData.apellidos,
        password: formData.password,
        tipoUserId: formData.tipoUsuario,


      };


      // eliminar password si viene vacío
      if (!payload.contrasena?.trim()) {
        delete payload.contrasena;
      }


      await updateDetailUser(formData.id, payload);

      await fetchData(0, 10);

      setSuccess(true);

      setTimeout(() => {
        setSuccess(false);
        setShowModal(false);
        resetForm();
      }, 2000);



    } catch (error) {
      console.error("Error en la solicitud:", error);
      //alert("Error al enviar el registro del comisiones: " + error.message);
      const response = error.response?.data;
      if (response?.validation) {
        setTimeout(() => setFieldErrors(response.validation), 1000);
        //setFieldErrors(response.validation);
      } else {
        setError(response?.detail || "Ocurrió un error inesperado");
      }
    }
  };


  return (
    <>
      <div className="flex">
        <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" backdrop="static">
          <Modal.Header>
            <Modal.Title><BsPersonLinesFill /> Editando Usuario: <b className="texto-modal">{nameuser}</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <form onSubmit={handleSubmitCambios}>

              <Row>
                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Nombre de usuario</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsBriefcaseFill /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="user"
                        value={formData.user}
                        onChange={handleChange}
                        required
                        className="form-control"
                      />
                    </InputGroup>
                  </div>
                </Col>
                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Nombre</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsFillPersonVcardFill /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="nombres"
                        value={formData.nombres}
                        onChange={handleChange}
                        required
                        className="form-control"
                      />
                    </InputGroup>
                  </div>
                </Col>

                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Apellidos</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsFillPersonVcardFill /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="apellidos"
                        value={formData.apellidos}
                        onChange={handleChange}
                        required
                        className="form-control"
                      />
                    </InputGroup>
                  </div>
                </Col>


                <Col Col xs={12} md={6} lg={6}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Contraseña</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <Bs123 /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type={showCodigo ? "text" : "password"}
                        name="password"
                        className="form-control"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Dejar en blanco para mantener la actual"
                        minLength={8}

                        required
                      />
                      <Button
                        variant="dark"
                        onClick={() => setShowCodigo(!showCodigo)}
                        type="button"
                      >
                        {showCodigo ? <BsEyeSlash /> : <BsEye />}
                      </Button>
                    </InputGroup>
                  </div>
                </Col>



                <Col Col xs={12} md={6} lg={6}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Tipo de usuario</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsFolderFill /> {" "}
                      </InputGroup.Text>
                      <Form.Select
                        name="tipoUsuario"
                        value={formData.tipoUsuario}
                        onChange={handleChange}
                        required
                        className="form-control"
                      >
                        <option value="">-- Elige una opción</option>
                        <option value="4">Junior</option>
                        <option value="2">Senior</option>
                        <option value="3">TISPC</option>
                        <option value="1">Administrador</option>
                      </Form.Select>

                    </InputGroup>
                  </div>
                </Col>
              </Row>
            </form>
            <br />
            {success && (
              <div className="alert alert-success">¡Usuario editado exitosamente!</div>

            )}

            {error && (
              <div className="alert alert-danger">{error}</div>
            )}

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => { setShowModal(false); resetForm(); }}>
              Cancelar
            </Button>
            <Button variant="success" onClick={handleSubmitCambios}>
              Guardar
            </Button>
          </Modal.Footer>

        </Modal>
        <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)} size="xl" backdrop="static">
          <Modal.Header>
            <Modal.Title><BsPersonFillAdd /> Añadir Usuario</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Nombre de usuario</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsBriefcaseFill /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="user"
                        value={formData.user}
                        onChange={handleChange}
                        required
                        className="form-control"
                      />
                    </InputGroup>
                  </div>
                </Col>
                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Nombre</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsFillPersonVcardFill /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="nombres"
                        value={formData.nombres}
                        onChange={handleChange}
                        required
                        className="form-control"
                      />
                    </InputGroup>
                  </div>
                </Col>

                <Col Col xs={12} md={6} lg={4}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Apellidos</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsFillPersonVcardFill /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="apellidos"
                        value={formData.apellidos}
                        onChange={handleChange}
                        required
                        className="form-control"
                      />
                    </InputGroup>
                  </div>
                </Col>




                <Col Col xs={12} md={6} lg={6}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Contraseña</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <Bs123 /> {" "}
                      </InputGroup.Text>
                      <Form.Control
                        type={showCodigo ? "text" : "password"}
                        name="password"
                        className="form-control"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder=""
                        minLength={8}

                        required
                      />
                      <Button
                        variant="dark"
                        onClick={() => setShowCodigo(!showCodigo)}
                        type="button"
                      >
                        {showCodigo ? <BsEyeSlash /> : <BsEye />}
                      </Button>
                    </InputGroup>
                  </div>
                </Col>



                <Col Col xs={12} md={6} lg={6}>
                  <div className="form-group mb-4">
                    <label className="form-label">
                      <b>Tipo de usuario</b>
                    </label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <BsFolderFill /> {" "}
                      </InputGroup.Text>
                      <Form.Select
                        name="tipoUsuario"
                        value={formData.tipoUsuario}
                        onChange={handleChange}
                        required
                        className="form-control"
                      >
                        <option value="">-- Elige una opción</option>
                        <option value="4">Junior</option>
                        <option value="2">Senior</option>
                        <option value="3">TISPC</option>
                        <option value="1">Administrador</option>
                      </Form.Select>

                    </InputGroup>
                  </div>
                </Col>
              </Row>
            </form>
            <br />

            {success && (
              <div className="alert alert-success">¡Usuario registrado exitosamente!</div>

            )}

            {error && (
              <div className="alert alert-danger">{error}</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => { setShowModalAdd(false); resetForm(); }} >
              Cancelar
            </Button>
            <Button variant="success" onClick={handleSubmit}>
              Registrar Usuario <GiKiwiBird />
            </Button>
          </Modal.Footer>
        </Modal>


        <Sidebar />
        <div className="content w-100 cont">
          <Navbar />

          <h3 className="text-center"><BsPersonFillGear /> Usuarios Registrados en el Sistema</h3>

          <Card className="card-tabla">
            <Table
              size="sm"
                hover
                responsive
                className="tablecursos text-center">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Rol</th>
                  <th>Usuario</th>
                  <th>Nombre</th>
                  <th>Activo</th>

                  <th colSpan={2}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((username, i) => (
                    <tr key={username.id}>
                      <td>{i + 1}</td>
                      <td>{username.id}</td>
                      <td>{username.rol}</td>
                      <td>{username.user}</td>
                      <td>{username.nombres} {username.apellidos}</td>

                      <td>
                        {username.activo === true ? (
                          <span className="badge bg-success">SI</span>
                        ) : (
                          <span className="badge bg-danger">NO</span>
                        )}
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2 mb-1 flex-wrap">
                          <OverlayTrigger overlay={(props) => (
                            <Tooltip id="tooltip-editar" {...props}>
                              Editar Usuario
                            </Tooltip>
                          )}
                          >
                            <Button variant="dark" 
                              onClick={() => handleOpenModal(username.id, username.nombres)}
                              disabled={username.rol === "SPCTI"}
                            >
                              <FaEdit />
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger overlay={(props) => (
                            <Tooltip id="tooltip-editar" {...props}>
                              {username.activo === "1" ? "Desactivar" : "Activar"} Usuario
                            </Tooltip>
                          )}
                          >
                            <Button
                              variant={username.activo === true ? "success" : "danger"}
                              onClick={() => handleToggleUserStatus(username)}
                              disabled={username.rol === "SPCTI"}
                            >
                              <FaExchangeAlt />
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No hay registros para mostrar
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card>
          <Card className="card-fix">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-2">
                <button
                  onClick={handleOpenModalAdd}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    usuarior: "pointer"
                  }}

                >
                  <img
                    className="imagen"
                    src="icons/registro.png"
                    alt="Nuevo usuario"
                    height={40}
                    width={40}
                  />
                </button>
                <InputGroup style={{ width: "300px" }}>
                  <InputGroup.Text>
                    <FcSearch />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Buscar por usuario..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </InputGroup>
              </div>

              <div className="d-flex align-items-center gap-2">
                <span>Registros por página:</span>
                <select
                  className="form-select form-select-sm"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  style={{ width: "80px" }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>

              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="text-muted">
                Mostrando{" "}
                <strong>
                  {currentPage * pageSize + 1}-
                  {Math.min((currentPage + 1) * pageSize, totalElements)}
                </strong>{" "}
                de <strong>{totalElements}</strong> registros
              </div>

              <div className="d-flex align-items-center gap-2">
                <Button
                  variant="light"
                  onClick={handlePrevious}
                  disabled={currentPage === 0}
                  className="d-flex align-items-center gap-1"
                >
                  <BsChevronLeft />
                  <span>Anterior</span>
                </Button>

                <Pagination className="mb-0">
                  {getPaginationItems()}
                </Pagination>

                <Button
                  variant="light"
                  onClick={handleNext}
                  disabled={currentPage >= totalPages - 1}
                  className="d-flex align-items-center gap-1"
                >
                  <span>Siguiente</span>
                  <BsChevronRight />
                </Button>
              </div>
            </div>

          </Card>


        </div>
      </div >

    </>
  );

}
